import { DashboardOverviewState } from '../types';
import {
  getDefaultTrendGranularity,
  getLastNDaysDateRange,
  getLastNDaysRange,
} from '../utils/dates';

const defaultDateRange = getLastNDaysDateRange(14);

export const dashboardOverviewState: DashboardOverviewState = {
  dateRange: defaultDateRange,
  terminal: null,
  granularity: getDefaultTrendGranularity(getLastNDaysRange(14)),
};
